import { round } from "lodash-es";

export interface TargetTPHValueInput {
	TargetTPH?: number | null;
	SectionTargetTPH?: number | null;
}

export interface TargetTPHPercentageInput {
	TargetTPHPercentage?: number | null;
	SectionTargetTPHPercentage?: number | null;
}

export interface ResolvedTargetTPHInput
	extends TargetTPHValueInput,
		TargetTPHPercentageInput {
	BudgetTPH?: number | null;
	SectionBudgetTPH?: number | null;
}

export const resolveTargetTPHValue = ({
	TargetTPH,
	SectionTargetTPH,
}: TargetTPHValueInput): number | null => TargetTPH ?? SectionTargetTPH ?? null;

export const resolveTargetTPHPercentage = ({
	TargetTPHPercentage,
	SectionTargetTPHPercentage,
}: TargetTPHPercentageInput): number =>
	TargetTPHPercentage ?? SectionTargetTPHPercentage ?? 80;

export const resolveTargetTPH = ({
	TargetTPH,
	SectionTargetTPH,
	TargetTPHPercentage,
	SectionTargetTPHPercentage,
	BudgetTPH,
	SectionBudgetTPH,
}: ResolvedTargetTPHInput): number | null => {
	const baseTargetTPH = resolveTargetTPHValue({ TargetTPH, SectionTargetTPH });

	if (baseTargetTPH == null) {
		const budgetTPH = BudgetTPH ?? SectionBudgetTPH ?? null;
		return budgetTPH == null ? null : round(budgetTPH, 2);
	}

	const resolvedPercentage = resolveTargetTPHPercentage({
		TargetTPHPercentage,
		SectionTargetTPHPercentage,
	});

	return round((baseTargetTPH * resolvedPercentage) / 100, 2);
};
